import { useState } from 'react';
import { IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const InputPassword = ({ tooltip, ...remaining }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      margin="normal"
      fullWidth
      type={showPassword ? 'text' : 'password'}
      {...remaining}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Tooltip title={tooltip}>
              <IconButton
                edge="end"
                onClick={() => setShowPassword(!showPassword)}
                onMouseDown={event => event.preventDefault()}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default InputPassword;
